import type { FC } from '../../lib/teact/teact';
import React, { useEffect, useState } from '../../lib/teact/teact';

import { isMediaDebugEnabled } from '../../util/mediaDebug';

type MediaDebugPanelComponent = typeof import('./MediaDebugPanel').default;

const MediaDebugPanelAsync: FC = () => {
  const [MediaDebugPanel, setMediaDebugPanel] = useState<MediaDebugPanelComponent | undefined>();

  useEffect(() => {
    if (!isMediaDebugEnabled()) return undefined;

    let isMounted = true;

    void import(/* webpackChunkName: "MediaDebugPanel" */ './MediaDebugPanel').then(({ default: Component }) => {
      if (isMounted) {
        setMediaDebugPanel(() => Component);
      }
    });

    return () => {
      isMounted = false;
    };
  }, []);

  return MediaDebugPanel ? <MediaDebugPanel /> : undefined;
};

export default MediaDebugPanelAsync;
